import CancelIcon from '@mui/icons-material/Cancel';

export const ShareHeader = ({ onClose }) => (
    <div className="top">
        <h3>
            Create Post
        </h3>
        
        <div className="closeBtn" onClick={onClose}>
            <CancelIcon />
        </div>
    </div>
);